'use client'

import { cn } from '@/lib/utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

function NavbarItem({ href, name, condition }) {
  return (
    <Link href={href} className="flex h-full flex-col justify-between">
      <p
        className={cn('h-full text-neutral-blue-200', {
          'text-white': condition,
        })}
      >
        {name}
      </p>
      <div
        className={cn('bg-gf-gradient hidden h-[2.5px] w-full', {
          block: condition,
        })}
      />
    </Link>
  )
}

export default function GameNavbar({ game, gameName }) {
  const path = usePathname().split('/')

  return (
    <div className="col-span-full mt-10 flex h-[37px] w-full gap-10 border-b border-neutral-blue-700 text-p-3 font-semibold desktop-xs:col-span-10 desktop-xs:col-start-2 desktop-xs:mt-8">
      <NavbarItem
        href={`/sim-racing-games/${gameName}`}
        name="Racing"
        condition={path.length === 3}
      />
      {['full', 'enhanced'].includes(game.liveryMarketplace) && (
        <NavbarItem
          href={`/sim-racing-games/${gameName}/liveries`}
          name="Liveries"
          condition={path.at(-1) === 'liveries'}
        />
      )}
      <NavbarItem
        href={`/sim-racing-games/${gameName}/communities`}
        name="Communities"
        condition={path.at(-1) === 'communities'}
      />
    </div>
  )
}
